import { getFunctions, httpsCallable } from "firebase/functions";
import { getApp } from "firebase/app";
import config from "./../../config.json";
import { log } from "../../helper/helper";

export function adminCarInbox() {
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const carInbox = httpsCallable(functions, config.adminCarInbox);
    log("Service name:" + config.adminCarInbox)

    return carInbox();
}

// **********************************************************************************

export function adminGetCarInfo(uid) {
    const data = { car_id: uid };
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const carInfo = httpsCallable(functions, config.adminGetCarInfo);
    log(data);
    log("Service name:" + config.adminGetCarInfo)
    return carInfo(data);
}

// **********************************************************************************
export function adminFindCar(regNumber, regState) {
    const data = { registration_number: regNumber, registration_state: regState };
    log(data);
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const findCar = httpsCallable(functions, config.adminFindCar);
    log("Service name:" + config.adminFindCar)

    return findCar(data);
}

// **********************************************************************************

export function getAdminInfo() {
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const adminGetAdminInfo = httpsCallable(functions, config.adminGetAdminInfo);
    log("Service name:" + config.adminGetAdminInfo)

    return adminGetAdminInfo();
}

// **********************************************************************************

export function adminCarChangeHidden(id, isHidden) {
    const data = { car_uid: id, is_hidden_by_user: isHidden };
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const findCar = httpsCallable(functions, config.adminCarChangeHidden);
    log("Service name:" + config.adminCarChangeHidden)

    return findCar(data);
}

// **********************************************************************************

export function adminMotorbikeRestrict(uid, statusNote) {
    const data = {
        car_uid: uid,
        car_status_note: statusNote,
    };
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const restrict = httpsCallable(functions, config.adminCarRestrict);
    log(data);
    log("Service name:" + config.adminCarRestrict)
    return restrict(data);
}

// **********************************************************************************

export function adminCarApprove(uid, note) {
    const data = { car_uid: uid, car_status_note: note };
    const functions = getFunctions(getApp(), config.australiaSoutheast);
    const documentReview = httpsCallable(functions, config.adminCarApprove);
    log(data);
    log("Service name:" + config.adminCarApprove)

    return documentReview(data);
}

// **********************************************************************************

export function adminCarFurtherInvestigation(uid, note) {
    const data = { car_uid: uid, car_status_note: note };
    const functions = getFunctions(getApp(), config.australiaSoutheast);

    const adminCarFurther = httpsCallable(
        functions,
        config.adminCarFurtherInvestigation
    );
    log(data);
    log("Service name:" + config.adminCarFurtherInvestigation)

    return adminCarFurther(data);
}

// **********************************************************************************

export function adminCarReject(uid, note) {
    const data = { car_uid: uid, car_status_note: note };
    const functions = getFunctions(getApp(), config.australiaSoutheast);

    const documentReject = httpsCallable(
        functions,
        config.adminCarReject
    );
    log(data);
    log("Service name:" + config.adminCarReject)

    return documentReject(data);
}
